import * as tConst from "../../../common/Constants";
import { pickColorAdo } from "../../../utils/pickColor";
import * as AzureService from "../../../api/ticketsApiAzure";
import findQuarterStart from "../data/findQuarterStart"; // Adjust the import path as necessary
import moment from "moment";

const emptyString = "";


export function PrepareTimelineDataAdo(items, viewId, assigneeFilterName = tConst.ADO_ASSIGNED_ALL, assigneeFilterTeam = tConst.VIEW_ALL_TEAMS, selectedInitiative = tConst.ADO_INITIATIVE_ALL, auth, quarterFilter = null, filterMinPlanningPri = Number.MIN_SAFE_INTEGER, filterMaxPlanningPri = Number.MAX_SAFE_INTEGER) {
    let dataset = [];
    let _minDate = new Date(2999, 11, 31);
    let _maxDate = new Date(1970, 0, 1);



    if (items != null && items.length > 0) {
        const tempItems2 = items.filter((item) => {
            const end = new Date(item.fields[tConst.AF_END_ITERATION])
            const status = item.fields[tConst.AF_STATE]
            const now = new Date()
            const from = new Date(item.fields[tConst.AF_START_ITERATION])

            //TODO: Delete all of this
            /*
            if (quarterFilter) {


                const  _startOfCalendarQuarterForSelectedFilter = moment(quarterFilter).startOf('quarter').toDate();
                const  _endOfCalendarQuarterForSelectedFilter = moment(quarterFilter).endOf('quarter').toDate();


                //_startOfCalendarQuarterForSelectedFilter.setHours(tConst.START_TIME, 0, 0)
                //_endOfCalendarQuarterForSelectedFilter.setHours(tConst.END_TIME, 0, 0)

              //  debugger;
                const nextTimelineQuarterStart = findQuarterStart(_endOfCalendarQuarterForSelectedFilter)
                const startofTimelineQuarter = findQuarterStart(_startOfCalendarQuarterForSelectedFilter)
                //nextTimelineQuarterStart.setDate(nextTimelineQuarterStart.getDate() + 1)

                if (end < startofTimelineQuarter.setHours(23,59,59) || from > nextTimelineQuarterStart.setHours(0,0,0))
                {
                    return false;
                }
            }
                */
            if ((viewId ? viewId : tConst.VIEW_ALL_PLANNED) === tConst.VIEW_ALL_PLANNED) {
                return true;
            } else if (viewId === tConst.VIEW_ACTIVE_AND_CURRENT) {
                return (end >= now || tConst.ADO_INACTIVE_STATUSES.indexOf(status) === -1)
            } else if (viewId === tConst.VIEW_ACTIVE) {
                return (tConst.ADO_INACTIVE_STATUSES.indexOf(status) === -1)
            } else if (viewId === tConst.VIEW_CURRENT_ITERATION) {
                return (end >= now && from <= now)
            } else if (viewId === tConst.VIEW_FUTURE) {
                return end >= now;
            }
            throw new Error("Invalid viewId: " + viewId)
        })

        dataset = tempItems2?.sort((a, b) => a.planningPri > b.planningPri ? 1 : -1).map((item) => {
            let fromDate = new Date(item.fields[tConst.AF_START_ITERATION])
            let endDate = new Date(item.fields[tConst.AF_END_ITERATION])
            if (endDate < fromDate) {
                const tempDate = fromDate;
                fromDate = endDate;
                endDate = tempDate;
            }
            if (_minDate > fromDate) {
                _minDate = fromDate;
            };
            if (_maxDate < endDate) {
                _maxDate = endDate;
            };

            const tooltip = "<div style='white-space: nowrap; margin: 1em;'>"
                + "[" + item.id + "] " + item.fields[tConst.AF_TITLE]
                + "<br/>Assignee: " + item.Assignee
                + "<br/>Status: " + item.fields[tConst.AF_STATE] + (item.fields[tConst.AF_PLANNING_STATUS] ? "&nbsp / &nbsp" + item.fields[tConst.AF_PLANNING_STATUS] : "")
                + "<br/>Priority: " + (item.planningPri ? item.planningPri : "<Unprioritized>") // + " / " + ticket.guestimate + " guestimate"
                + "<br/>Period: " + tConst.formatDate(fromDate) + " - " + tConst.formatDate(endDate)
                + "<br/>Epic/ Initiativ: " + emptyString + "<epic>" + emptyString + " / " + item.fields[tConst.AF_INITIATIV]
                + "<br/>Type: " + item.fields[tConst.AF_WORKITEM_TYPE]
                + (item.Project && item.Project === "RnD Planning" ? "<br/>Teams: " + item.Teams.join(", ") : "<br/>Project: " + item.Project)
                + "</div>";

            const _type = item.fields[tConst.AF_WORKITEM_TYPE]
            const prefix = _type === "Epic" ? "E " : _type === "Initiative" ? "I " : _type === "Feature" ? "F " : _type === "Product Backlog Item" ? "P " : "";

            let _dimColor = false;
            if (assigneeFilterName !== tConst.ADO_ASSIGNED_ALL) {
                _dimColor = (assigneeFilterName !== item.Assignee)
            }
            if (assigneeFilterTeam === tConst.VIEW_NO_TEAMS) {
                _dimColor = (item.Teams.length !== 0)
            }
            else if (assigneeFilterTeam !== tConst.VIEW_ALL_TEAMS) {
                _dimColor = ((item.Teams.indexOf(assigneeFilterTeam) === -1) && item.Project !== assigneeFilterTeam)
            }
            if (filterMinPlanningPri !== Number.MIN_SAFE_INTEGER || filterMaxPlanningPri !== Number.MAX_SAFE_INTEGER) {            
                _dimColor = (item.planningPri < filterMinPlanningPri || item.planningPri > filterMaxPlanningPri)
            }

            return [
                item.GroupBy ? item.GroupBy : ((item.fields[tConst.AF_INITIATIV] && item.fields[tConst.AF_INITIATIV] !== "") ? item.fields[tConst.AF_INITIATIV] : ".."),
                prefix + "[" + item.id + "] " + item.fields[tConst.AF_TITLE],
                tooltip,
                pickColorAdo(item, _dimColor),
                fromDate,
                endDate
            ]
        })
    }


    return { dataset, minDate: _minDate, maxDate: _maxDate }

}

